export function ui() {

    (function() {
        //Featured Articles Block - Set CSS variable for header height 
        (function() {
            const headerH = $('.sub-article-title').outerHeight();
            //console.log(headerH);
            document.documentElement.style.setProperty('--header-height', headerH + 'px');
        })();

        // Mark the last visible section for CSS targeting
        // TEST: disabled to see if the footer works without this class
        // (footer.js now handles the footer waves background directly)
        // const sections = [...document.querySelectorAll('main > section')];
        // const lastVisible = sections.reverse().find(s => getComputedStyle(s).display !== 'none');
        // if (lastVisible) lastVisible.classList.add('last-visible-section');



        (function() {
            //Hero Small Wave
            $('.hero-small').each(function() {
                const imageUrl = $(this).data('wave'); // Get the data-wave value
                $(this).css('--wave', `url(${imageUrl})`); // Set the CSS variable
                //$(this).find('.mobile-image').css('--wave', `url(${imageUrl})`);
            });

            //Hero Medium Wave
            $('.hero-medium').each(function() {
                const imageUrl = $(this).data('wave'); // Get the data-wave value
                $(this).css('--wave', `url(${imageUrl})`); // Set the CSS variable
                //$(this).find('.mobile-image').css('--wave', `url(${imageUrl})`);
            });
        })();

        $('.wave-before').each(function() {
            const imageUrl = $(this).data('wave'); // Get the data-wave value
            $(this).css('--wave', `url(${imageUrl})`); // Set the CSS variable
        });

        //Hero Large Wave
        $('.hero-large').each(function() {
            const imageUrl = $(this).data('wave'); // Get the data-wave value
            $(this).css('--wave', `url(${imageUrl})`); // Set the CSS variable
            //Below the lg breakpoint .bg-hero:after draws the wave over the image (see _block-hero.scss)
            $(this).find('.bg-hero').css('--wave', `url(${imageUrl})`);
        });
        
    })();

    /**
     * Label Animation
     */
    (function () {
        let field = $('.field').find('input, textarea');

        $(field).on('focus', function () {
            $(this).prev('label').addClass('label-animate-active');
        });

        $(field).on('blur', function () {
            if ($(this).val().length == 0) {
                $(this).prev('label').removeClass('label-animate-active');
            }
        });
    })();
   
}